import { useAddMaximumCommutePreferenceMutation } from "./__generated__/useAddMaximumCommutePreference.gqlgenerated";

import { useCallback } from "react";

export function useAddMaximumCommutePreference() {
  const [addMaximumCommutePreferenceMutation] = useAddMaximumCommutePreferenceMutation();
  return useCallback(
    async (timeMinutes: number) => {
      const { data } = await addMaximumCommutePreferenceMutation({
        variables: { timeMinutes },
      });
      const preference = data?.addJobSeekerProfileStructuredDataPreference?.preference;
      if (!preference?.id) {
        throw new Error("AddMaximumCommutePreference returned no preference");
      }
      return preference;
    },
    [addMaximumCommutePreferenceMutation],
  );
}
